/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralSettings } from '../../models/general-settings';
import { OrganizationOr } from '../../models/organization-or';

export interface AddOrUpdateGeneralSettings$Params {
      body: GeneralSettings
}

export function addOrUpdateGeneralSettings(http: HttpClient, rootUrl: string, params: AddOrUpdateGeneralSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationOr>> {
  const rb = new RequestBuilder(rootUrl, addOrUpdateGeneralSettings.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationOr>;
    })
  );
}

addOrUpdateGeneralSettings.PATH = '/api/GeneralSettings/addOrUpdateGeneralSettings';
